<app-global-loader></app-global-loader>
<router-outlet></router-outlet>
